import { AppNextLink } from '@/features/app-next-link';
import { IconArrowSquareLeft } from '@/components/svg-symbols/icons';
import { getPDPBreadcrumb } from '../../_utils/get-pdp-breadcrumb';
import usePDPData from '../../_utils/use-pdp-data';
const PDPBreadcrumb = () => {
  const {
    data
  } = usePDPData();
  const {
    breadcrumbBrandCategory,
    breadcrumb,
    brand
  } = data || {};
  const {
    breadcrumbPath,
    breadcrumbTitle,
    brandPath
  } = getPDPBreadcrumb(breadcrumb || [], breadcrumbBrandCategory || null, brand || null);
  return <div className='flex flex-row flex-wrap items-center gap-0.5 text-body-14 text-text-darkGray lg:font-medium' data-sentry-component="PDPBreadcrumb" data-sentry-source-file="pdp-breadcrumb.tsx">
            <AppNextLink prefetch={false} href={brandPath} data-sentry-element="AppNextLink" data-sentry-source-file="pdp-breadcrumb.tsx">
                {brand?.nameFa}
            </AppNextLink>

            <IconArrowSquareLeft className='h-5 w-5' data-sentry-element="IconArrowSquareLeft" data-sentry-source-file="pdp-breadcrumb.tsx" />

            <AppNextLink prefetch={false} href={breadcrumbPath} data-sentry-element="AppNextLink" data-sentry-source-file="pdp-breadcrumb.tsx">
                {breadcrumbTitle}
            </AppNextLink>
        </div>;
};
export default PDPBreadcrumb;